/**
 * 应用管理
 */
const ApplyManagePark = () => import('@/views/applyManage/park') // 园区应用

export default {
  ApplyManagePark
}
